module.exports = __webpack_public_path__ + "img/about_us_SB.563b8445.png";